export default __webpack_public_path__ + "static/media/lucky-spin.27b9fdeb.gif";